<template>
  <div ref="baseRef">
    <label class="text-input-label">
      {{$t(label)}}
    </label>
    <v-autocomplete
    v-model="model"
    @input="$emit('input')"
    @focus="onFocus"
    @blur="onBlur"
    :placeholder="$t(placeholder)"
    :item-text="itemText"
    :item-value="itemValue"
    :rules="rules"
    return-object
    hide-details="auto"
    :dense="normal"
    :outlined="outlined"
    :items="items"
    :disabled="disabled"
    :loading="loading"
    class="sys-field"
    clearable>
      <template v-slot:[`selection`]="{ item }">
        <span>{{item.name && item.name !== undefined ? $t(item.name) : (item.value && item.value !== undefined ? $t(item.value) : (item.model && item.model !== undefined ? $t(item.model) : $t('textFields.setNameOrValueProperty')))}}</span>
      </template>
      <template v-slot:item="{item}">
        <v-row 
        justify="space-between"
        dense>
          <v-col :cols="item.imageUrl ? 5 : 12">
            <span>{{item.name && item.name !== undefined ? $t(item.name) : (item.value && item.value !== undefined ? $t(item.value) : (item.model && item.model !== undefined ? $t(item.model) : $t('textFields.setNameOrValueProperty')))}}</span>
          </v-col>
          <v-col 
          v-if="item.imageUrl"
          cols="3">
            <div>
              <v-img :src="item.imageUrl" height="50" contain width="50"/>
            </div>
          </v-col>
        </v-row>
      </template>
    </v-autocomplete>
  </div>
</template>
<script>
export default {
  props: {
    label: String,
    placeholder: String,
    items: Array,
    value: Object,
    normal: Boolean,
    disabled: Boolean,
    itemText: String,
    itemValue: String,
    required: Boolean,
    outlined: Boolean,
    loading: {
      type: Boolean,
      default: false
    }
  },
  model: {
    prop: 'value',
    event: 'valueChanged'
  },
  data() {
    return {
      rules: [
        v => this.required ? (!!v || this.$t('invalidValue.required')) : true
      ]
    }
  },
  computed: {
    model: {
      get: function() {
        return this.$props.value
      },
      set: function(v) {
        this.$emit('valueChanged', v)
      }
    }
  },
  methods: {
    onFocus() {
      this.showInput()
    },
    onBlur() {
      this.hideInput()
    },
    showInput() {
      const CONT_EL = this.$refs.baseRef.querySelector(".sys-field.v-input .v-select__selections")
      CONT_EL.style.flexWrap = "wrap"
      const INPUT_EL = this.$refs.baseRef.querySelector(".sys-field.v-input .v-select__selections > input")
      INPUT_EL.style.minWidth = "60px"
    },
    hideInput() {
      const CONT_EL = this.$refs.baseRef.querySelector(".sys-field.v-input .v-select__selections")
      CONT_EL.style.flexWrap = "nowrap"
      const INPUT_EL = this.$refs.baseRef.querySelector(".sys-field.v-input .v-select__selections > input")
      INPUT_EL.style.minWidth = "10px"
    }
  },
  mounted() {
    this.hideInput()
  }
}
</script>
<style>
.text-input {
  width: 100%;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5; 
  
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
}

div.text-input > div.v-input__control > div.v-input__slot > div.v-text-field__slot > input {
  color: #495057;
}

.text-input-border-color.v-text-field.v-text-field--is-booted.v-text-field--enclosed.v-text-field--outlined {
  border: 1px solid #49505742;
}

.text-input-label {
  color: #495057;
  font-family: 'Titillium Web', sans-serif;
  font-weight: 300;
  font-size: 1rem;
  letter-spacing: 1px;
}
</style>